import { type AxiosRequestConfig } from 'axios'

const updateUserJob = (id: string, data: any): AxiosRequestConfig => {
  return {
    method: 'PUT',
    url: '/user/info/job/item',
    data,
    params: {
      id
    }
  }
}

export { updateUserJob }
